import { Route } from "react-router";
import { NESTED_ROUTE_PATH, WILDCARD_ROUTE } from "../common/constants";
import { AFFILIATE_PARTNER_ROUTE_PREFIX } from "../modules/affiliate/paths";
import AffiliatePartnerRoutes from "../modules/affiliate/routes";
import {
  AGENT_DIRECTORATE_ROUTE_PREFIX,
  AGENT_EDUCATION_ROUTE_PREFIX,
  AGENT_ROUTE_PATHS,
  AGENT_ROUTE_PREFIX,
} from "../modules/agent/paths";
import { AgentDirectorateRoutes, AgentEducationRoutes, AgentRoutes } from "../modules/agent/routes";
import LoginWrapper from "../modules/auth/components/LoginWrapper";
import { LoginContainer } from "../modules/auth/containers/LoginContainer";
import { AUTH_ROUTE_PATHS } from "../modules/auth/paths";
import { BUG_REPORT_ROUTE_PATHS } from "../modules/bugreport/paths";
import { CALC_BLACKLIST_ROUTE_PREFIX } from "../modules/calculator/blacklist/paths";
import CalcBlacklistRoutes from "../modules/calculator/blacklist/routes";
import { CALC_ROUTE_PATHS, CALC_ROUTE_PREFIX } from "../modules/calculator/paths";
import CalcRoutes from "../modules/calculator/routes";
import { ADMIN_CALC_ROUTE_PATHS, ADMIN_CALC_ROUTE_PREFIX } from "../modules/calculator/settings/paths";
import CalcSettingsRoutes from "../modules/calculator/settings/routes";
import { CLIENT_ROUTE_PATHS, CLIENT_ROUTE_PREFIX } from "../modules/client/paths";
import ClientRoutes from "../modules/client/routes";
import { COMMISSIONS_BATCH_ROUTE_PATHS, COMMISSIONS_BATCH_ROUTE_PREFIX } from "../modules/commissions/batch/paths";
import CommissionsBatchRoutes from "../modules/commissions/batch/routes";
import { COMMISSIONS_LEVEL_ROUTE_PATHS, COMMISSIONS_LEVEL_ROUTE_PREFIX } from "../modules/commissions/level/paths";
import CommissionsLevelRoutes from "../modules/commissions/level/routes";
import { COMMISSIONS_OUTPUTS_ROUTE_PREFIX } from "../modules/commissions/outputs/paths";
import { CommissionsOutputsRoutes } from "../modules/commissions/outputs/routes";
import { POSTPONED_COMMISSIONS_ROUTE_PREFIX } from "../modules/commissions/postponed/paths";
import PostponedCommissionsRoutes from "../modules/commissions/postponed/routes";
import { COMMISSION_PROMOTIONS_ROUTE_PREFIX } from "../modules/commissions/promotions/paths";
import { routes as CommissionPromotionRoutes } from "../modules/commissions/promotions/routes";
import { COMMISSIONS_SETTINGS_RANKS_ROUTE_PREFIX } from "../modules/commissions/ranks/paths";
import { CommissionsSettingsRanksRoutes } from "../modules/commissions/ranks/routes";
import { SPLIT_COMMISSIONS_ROUTE_PREFIX } from "../modules/commissions/splitcommissions/paths";
import { SplitCommissionsRoutes } from "../modules/commissions/splitcommissions/routes";
import { COMPETITION_ROUTE_PREFIX } from "../modules/competition/path";
import { CompetitionRoutes } from "../modules/competition/routes";
import { COMPLICITY_ROUTE_PREFIX } from "../modules/complicity/paths";
import ComplicityRoutes from "../modules/complicity/routes";
import { CONTRACT_ROUTE_PATHS, CONTRACT_ROUTE_PREFIX } from "../modules/contract/paths";
import ContractRoutes from "../modules/contract/routes";
import { CONTRACT_UPDATE_ROUTE_PREFIX } from "../modules/contractupdate/paths";
import ContractUpdateRoutes from "../modules/contractupdate/routes";
import { COVERAGE_LIMIT_ROUTE_PREFIX } from "../modules/coveragelimit/paths";
import CoverageLimitRoutes from "../modules/coveragelimit/routes";
import { DashboardContainer } from "../modules/dashboard/containers/DashboardContainer";
import { DASHBOARD_ROUTE_PATHS, DASHBOARD_ROUTE_PREFIX } from "../modules/dashboard/paths";
import { ConfirmDocumentSignContainer } from "../modules/docsignature/containers/ConfirmDocumentSignContainer";
import { CLIENT_DOCUMENT_SIGN_PATHS } from "../modules/docsignature/paths";
import { DOCUMENT_NODE_ROUTE_PATHS, DOCUMENT_NODE_ROUTE_PREFIX } from "../modules/documents/paths";
import DocumentNodeRoutes from "../modules/documents/routes";
import { CONFIG_PROPERTY_ROUTE_PREFIX } from "../modules/dynamicconfig/paths";
import ConfigPropertyRoutes from "../modules/dynamicconfig/routes";
import { FINANCIAL_MEDIATION_ROUTE_PATHS, FINANCIAL_MEDIATION_ROUTE_PREFIX } from "../modules/financialmediation/paths";
import FinancialMediationRoutes from "../modules/financialmediation/routes";
import { INSTITUTION_ROUTE_PREFIX } from "../modules/institution/paths";
import InstitutionRoutes from "../modules/institution/routes";
import { JOB_ROUTE_PREFIX } from "../modules/jobs/paths";
import JobRoutes from "../modules/jobs/routes";
import { LIFE_INSURENCE_TARIFF_ROUTE_PREFIX } from "../modules/lifeinsurancetariff/paths";
import LifeInsuranceTariffRoutes from "../modules/lifeinsurancetariff/routes";
import { NOTIFICATION_ROUTE_PREFIX } from "../modules/notifications/paths";
import NotificationRoutes from "../modules/notifications/routes";
import { OVERVIEWS_ROUTE_PREFIX } from "../modules/overviews/paths";
import { OverviewsRoutes } from "../modules/overviews/routes";
import { PARTNER_ROUTE_PREFIX } from "../modules/partner/paths";
import PartnerRoutes from "../modules/partner/routes";
import { PRODUCT_ROUTE_PREFIX } from "../modules/product/paths";
import ProductRoutes from "../modules/product/routes";
import { ConfirmUserContainer } from "../modules/user/containers/ConfirmUserContainer";
import { RequestPasswordResetContainer } from "../modules/user/containers/RequestPasswordResetContainer";
import { ResetPasswordContainer } from "../modules/user/containers/ResetPasswordContainer";
import { UpdateEmailContainer } from "../modules/user/containers/UpdateEmailContainer";
import { ADMIN_USER_ROUTE_PREFIX, CURRENT_USER_ROUTE_PREFIX, USER_ROUTE_PATHS } from "../modules/user/paths";
import { AdminUserRoutes, CurrentUserRoutes } from "../modules/user/routes";
import { VEHICLE_BRAND_ROUTE_PREFIX } from "../modules/vehicle/brand/paths";
import VehicleBrandRoutes from "../modules/vehicle/brand/routes";
import { VEHICLE_ENUM_ROUTE_PREFIX } from "../modules/vehicle/paths";
import VehicleEnumRoutes from "../modules/vehicle/routes";
import { AttachmentBoundary } from "./components/boundaries/attachment/AttachmentBoundary";
import { ATTACHMENT_BOUNDARY_TYPE } from "./components/boundaries/attachment/enums";
import { RedirectWithParams } from "./components/RedirectWithParams";
import { MobileApp } from "./pages/mobile-app/MobileApp";
import { NotFound } from "./pages/NotFound";

export const agentRoleRoutes = (
  <>
    <Route index element={<DashboardContainer />} />

    <Route path={NOTIFICATION_ROUTE_PREFIX + NESTED_ROUTE_PATH} element={<NotificationRoutes />} />

    <Route path={COMPETITION_ROUTE_PREFIX + NESTED_ROUTE_PATH} element={<CompetitionRoutes />} />

    <Route path={CLIENT_ROUTE_PREFIX + NESTED_ROUTE_PATH} element={<ClientRoutes />} />

    <Route path={CONTRACT_ROUTE_PREFIX + NESTED_ROUTE_PATH} element={<ContractRoutes />} />

    <Route path={FINANCIAL_MEDIATION_ROUTE_PREFIX + NESTED_ROUTE_PATH} element={<FinancialMediationRoutes />} />

    <Route path={CALC_ROUTE_PREFIX + NESTED_ROUTE_PATH} element={<CalcRoutes />} />

    <Route path={PARTNER_ROUTE_PREFIX + NESTED_ROUTE_PATH} element={<PartnerRoutes />} />

    <Route path={AGENT_ROUTE_PREFIX + NESTED_ROUTE_PATH} element={<AgentRoutes />} />

    <Route path={AGENT_DIRECTORATE_ROUTE_PREFIX + NESTED_ROUTE_PATH} element={<AgentDirectorateRoutes />} />

    <Route path={AGENT_EDUCATION_ROUTE_PREFIX + NESTED_ROUTE_PATH} element={<AgentEducationRoutes />} />

    <Route path={OVERVIEWS_ROUTE_PREFIX + NESTED_ROUTE_PATH} element={<OverviewsRoutes />} />

    <Route path={DOCUMENT_NODE_ROUTE_PREFIX + NESTED_ROUTE_PATH} element={<DocumentNodeRoutes />} />

    <Route path={COMMISSIONS_BATCH_ROUTE_PREFIX + NESTED_ROUTE_PATH} element={<CommissionsBatchRoutes />} />

    <Route path={COMMISSIONS_OUTPUTS_ROUTE_PREFIX + NESTED_ROUTE_PATH} element={<CommissionsOutputsRoutes />} />

    <Route path={POSTPONED_COMMISSIONS_ROUTE_PREFIX + NESTED_ROUTE_PATH} element={<PostponedCommissionsRoutes />} />

    <Route path={SPLIT_COMMISSIONS_ROUTE_PREFIX + NESTED_ROUTE_PATH} element={<SplitCommissionsRoutes />} />

    <Route path={COMMISSIONS_LEVEL_ROUTE_PREFIX + NESTED_ROUTE_PATH} element={<CommissionsLevelRoutes />} />

    <Route
      path={COMMISSIONS_SETTINGS_RANKS_ROUTE_PREFIX + NESTED_ROUTE_PATH}
      element={<CommissionsSettingsRanksRoutes />}
    />

    <Route path={COMMISSION_PROMOTIONS_ROUTE_PREFIX + NESTED_ROUTE_PATH} element={<CommissionPromotionRoutes />} />

    <Route path={ADMIN_USER_ROUTE_PREFIX + NESTED_ROUTE_PATH} element={<AdminUserRoutes />} />

    <Route path={CURRENT_USER_ROUTE_PREFIX + NESTED_ROUTE_PATH} element={<CurrentUserRoutes />} />

    <Route path={INSTITUTION_ROUTE_PREFIX + NESTED_ROUTE_PATH} element={<InstitutionRoutes />} />

    <Route path={PRODUCT_ROUTE_PREFIX + NESTED_ROUTE_PATH} element={<ProductRoutes />} />

    <Route path={AFFILIATE_PARTNER_ROUTE_PREFIX + NESTED_ROUTE_PATH} element={<AffiliatePartnerRoutes />} />

    <Route path={ADMIN_CALC_ROUTE_PREFIX + NESTED_ROUTE_PATH} element={<CalcSettingsRoutes />} />

    <Route path={CONTRACT_UPDATE_ROUTE_PREFIX + NESTED_ROUTE_PATH} element={<ContractUpdateRoutes />} />

    <Route path={LIFE_INSURENCE_TARIFF_ROUTE_PREFIX + NESTED_ROUTE_PATH} element={<LifeInsuranceTariffRoutes />} />

    <Route path={VEHICLE_ENUM_ROUTE_PREFIX + NESTED_ROUTE_PATH} element={<VehicleEnumRoutes />} />

    <Route path={VEHICLE_BRAND_ROUTE_PREFIX + NESTED_ROUTE_PATH} element={<VehicleBrandRoutes />} />

    <Route path={COVERAGE_LIMIT_ROUTE_PREFIX + NESTED_ROUTE_PATH} element={<CoverageLimitRoutes />} />

    <Route path={COMPLICITY_ROUTE_PREFIX + NESTED_ROUTE_PATH} element={<ComplicityRoutes />} />

    <Route path={JOB_ROUTE_PREFIX + NESTED_ROUTE_PATH} element={<JobRoutes />} />

    <Route path={CALC_BLACKLIST_ROUTE_PREFIX + NESTED_ROUTE_PATH} element={<CalcBlacklistRoutes />} />

    <Route path={CONFIG_PROPERTY_ROUTE_PREFIX + NESTED_ROUTE_PATH} element={<ConfigPropertyRoutes />} />

    <Route path={WILDCARD_ROUTE} element={<NotFound />} />
  </>
);

export const clientRoleRoutes = (
  <>
    <Route path={DASHBOARD_ROUTE_PREFIX} element={<MobileApp />} />

    <Route path={WILDCARD_ROUTE} element={<NotFound />} />
  </>
);

export const attachmentRoutes = (
  <>
    <Route
      path={AGENT_ROUTE_PATHS.attachment.to}
      element={<AttachmentBoundary type={ATTACHMENT_BOUNDARY_TYPE.AGENT} />}
    />

    <Route
      path={BUG_REPORT_ROUTE_PATHS.attachment.to}
      element={<AttachmentBoundary type={ATTACHMENT_BOUNDARY_TYPE.BUG_REPORT} />}
    />

    <Route
      path={CALC_ROUTE_PATHS.draftAttachment.to}
      element={<AttachmentBoundary type={ATTACHMENT_BOUNDARY_TYPE.CALCULATOR_DRAFT} />}
    />

    <Route
      path={CALC_ROUTE_PATHS.resultAttachment.to}
      element={<AttachmentBoundary type={ATTACHMENT_BOUNDARY_TYPE.CALCULATOR_RESULT} />}
    />

    <Route
      path={ADMIN_CALC_ROUTE_PATHS.attachmentConf.to}
      element={<AttachmentBoundary type={ATTACHMENT_BOUNDARY_TYPE.CALCULATOR_SETTING} />}
    />

    <Route
      path={CLIENT_ROUTE_PATHS.attachment.to}
      element={<AttachmentBoundary type={ATTACHMENT_BOUNDARY_TYPE.CLIENT} />}
    />

    <Route
      path={CLIENT_ROUTE_PATHS.importResultFile.to}
      element={<AttachmentBoundary type={ATTACHMENT_BOUNDARY_TYPE.CLIENT_IMPORT_RESULT} />}
    />

    <Route
      path={COMMISSIONS_BATCH_ROUTE_PATHS.input.to}
      element={<AttachmentBoundary type={ATTACHMENT_BOUNDARY_TYPE.COMMISSIONS_BATCH_INPUT} />}
    />

    <Route
      path={COMMISSIONS_BATCH_ROUTE_PATHS.output.to}
      element={<AttachmentBoundary type={ATTACHMENT_BOUNDARY_TYPE.COMMISSIONS_BATCH_OUTPUT} />}
    />

    <Route
      path={COMMISSIONS_BATCH_ROUTE_PATHS.legacyOutput.to}
      element={<RedirectWithParams to={COMMISSIONS_BATCH_ROUTE_PATHS.output.to} />}
    />

    <Route
      path={COMMISSIONS_LEVEL_ROUTE_PATHS.attachment.to}
      element={<AttachmentBoundary type={ATTACHMENT_BOUNDARY_TYPE.COMMISSIONS_LEVEL} />}
    />

    <Route
      path={AGENT_ROUTE_PATHS.commissionsSettingsAttachment.to}
      element={<AttachmentBoundary type={ATTACHMENT_BOUNDARY_TYPE.COMMISSIONS_SETTINGS} />}
    />

    <Route
      path={AGENT_ROUTE_PATHS.commissionsOutput.to}
      element={<AttachmentBoundary type={ATTACHMENT_BOUNDARY_TYPE.COMMISSIONS_OUTPUT} />}
    />

    <Route
      path={AGENT_ROUTE_PATHS.importResultFile.to}
      element={<AttachmentBoundary type={ATTACHMENT_BOUNDARY_TYPE.AGENT_IMPORT_RESULT} />}
    />

    <Route
      path={CONTRACT_ROUTE_PATHS.attachment.to}
      element={<AttachmentBoundary type={ATTACHMENT_BOUNDARY_TYPE.CONTRACT} />}
    />

    <Route
      path={CONTRACT_ROUTE_PATHS.importResultFile.to}
      element={<AttachmentBoundary type={ATTACHMENT_BOUNDARY_TYPE.CONTRACT_IMPORT_RESULT} />}
    />

    <Route
      path={DASHBOARD_ROUTE_PATHS.noticeAttachment.to}
      element={<AttachmentBoundary type={ATTACHMENT_BOUNDARY_TYPE.DASHBOARD_NOTICE} />}
    />

    <Route
      path={DOCUMENT_NODE_ROUTE_PATHS.attachment.to}
      element={<AttachmentBoundary type={ATTACHMENT_BOUNDARY_TYPE.DOCUMENT_NODE} />}
    />

    <Route
      path={FINANCIAL_MEDIATION_ROUTE_PATHS.file.to}
      element={<AttachmentBoundary type={ATTACHMENT_BOUNDARY_TYPE.FINANCIAL_MEDIATION} />}
    />

    <Route
      path={CLIENT_DOCUMENT_SIGN_PATHS.originalFile.to}
      element={<AttachmentBoundary type={ATTACHMENT_BOUNDARY_TYPE.CLIENT_DOCUMENT_SIGN_ORIGINAL} />}
    />

    <Route
      path={CLIENT_DOCUMENT_SIGN_PATHS.signedFile.to}
      element={<AttachmentBoundary type={ATTACHMENT_BOUNDARY_TYPE.CLIENT_DOCUMENT_SIGN_SIGNED} />}
    />
  </>
);

export const publicRoutes = (
  <>
    <Route path={AUTH_ROUTE_PATHS.login.to} element={<LoginWrapper component={<LoginContainer />} />} />

    <Route path={USER_ROUTE_PATHS.confirm.to} element={<ConfirmUserContainer />} />

    <Route path={USER_ROUTE_PATHS.updateEmail.to} element={<UpdateEmailContainer />} />

    <Route path={USER_ROUTE_PATHS.requestPasswordReset.to} element={<RequestPasswordResetContainer />} />

    <Route path={USER_ROUTE_PATHS.resetPassword.to} element={<ResetPasswordContainer />} />

    <Route path={USER_ROUTE_PATHS.mobileApp.to} element={<MobileApp />} />

    <Route path={CLIENT_DOCUMENT_SIGN_PATHS.confirm.to} element={<ConfirmDocumentSignContainer />} />
  </>
);
